export default "__VITE_ASSET__CNmRGtdP__";